import { LoadablePaint } from '@confluence/loadable';

export const AISearchPage = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AISearchMain" */ './AISearchMain.tsx')).AISearchMain,
});
